import { addListsModalActionTypes } from './Constants';

const initialState = {
	loading: false,
	lists: [],
	isOpenAddListModal: false,
	addListModalLoading: false,
	modalTitle: '',
	subjectId: null,
	groupId: null,
	type: null,
	setOpen: null,
	closeModal: null,
	submitModal: null,
	openAdditionalModal: null,
	triggerModalClosing: null,
	submitLoading: null,
	parentList: [],
	exerciseTypes: [],
	isCombinedPractisingModal: false,
	selectedList: null,
};

export default function addListsModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case addListsModalActionTypes.GET_LIST_REQUEST:
			return {
				...state,
				loading: true,
			};

		case addListsModalActionTypes.GET_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data,
			};

		case addListsModalActionTypes.TOGGLE_ADD_LIST_MODAL:
			return {
				...state,
				loading: false,
				...data,
			};

		case addListsModalActionTypes.GET_LIST_ERROR:
			return {
				...state,
				loading: false,
				isOpenAddListModal: false,
			};
		case addListsModalActionTypes.CLEAR_ADD_LIST_MODAL_STATE:
			return initialState;

		default:
			return state;
	}
}
